// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-model[data-v-55524a82]{position:fixed;left:0;top:0;right:0;bottom:0;background:rgba(0,0,0,.47);z-index:10000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
